export default () => {
    function mapCountryCodetoShoptetId(countryCode)
    {
      var shoptedId = 43;
      switch (countryCode) {
        case "BE" :
            shoptedId = 14;
            break;
        case "BG" :
            shoptedId = 16;
            break;
        case "CZ" :
            shoptedId = 43;
            break;
        case "DK":
            shoptedId = 46;
            break;
        case "EE" :
            shoptedId = 50;
            break;
        case "FI" :
            shoptedId = 54;
            break;
        case "FR" :
            shoptedId = 55;
            break;
        case "HR" :
            shoptedId = 73;
            break;
        case "IE" :
            shoptedId = 77;
            break;
        case "IT" :
            shoptedId = 83;
            break;
        case "QA" :
            shoptedId = 184;
            break;
        case "CY" :
            shoptedId = 42;
            break;
        case "LT" :
            shoptedId = 101;
            break;
        case "LV" :
            shoptedId = 103;
            break;
        case "LU" :
            shoptedId = 102;
            break;
        case "HU" :
            shoptedId = 75;
            break;
        case "MT" :
            shoptedId = 114;
            break;
        case "DE" :
            shoptedId = 44;
            break;
        case "NL" :
            shoptedId = 126;
            break;
        case "NO" :
            shoptedId = 127;
            break;
        case "PL" :
            shoptedId = 136;
            break;
        case "PT" :
            shoptedId = 139;
            break;
        case "AT" :
            shoptedId = 8;
            break;
        case "RO" :
            shoptedId = 141
            break;
        case "GR" :
            shoptedId = 67
            break;
        case "SG" :
            shoptedId = 149
            break;
        case "SK" :
            shoptedId = 151
            break;
        case "SI" :
            shoptedId = 150
            break;
        case "ES" :
              shoptedId = 52;
              break;
        case "SE" :
            shoptedId =148
            break;
        case "GB" :
            shoptedId = 57
            break;
      }

      return shoptedId;
    }

    const cart = $(".ordering-process").length;

    if (cart) {
        const isEN = shoptet.cookie.get("language") === "en";  
        var isEUR = true;
        const currencyText = $("div[data-target=\"currency\"].js-languagesMenu__box .languagesMenu__header--actual");
        if (currencyText.length > 0)
        {
            if (currencyText[0].innerText === "KČ") {
                isEUR = false;
            }
        }
        else {
            isEUR = isEN;
        }
        
        const deliveryType = isEN ? `<span class="added-block">Shipping method</span>` : `<span class="added-block">Způsob dopravy</span>`;
        const paymentType = isEN ? `<span class="added-block">Payment</span>` : `<span class="added-block">Platba</span>`;
        const price = document.querySelector(".price.price-primary");
        const copyrightText = isEN ? "Copyright 2019-2023 The Miners, All rights reserved." : "Copyright 2019-2023 Miners, Všechna práva vyhrazena.";

        if (price) {
            const priceSecondaryLabel = document.querySelector(".price-label.price-secondary");
            const priceSecondary = document.querySelector(".price.price-secondary");

            if (priceSecondaryLabel && priceSecondary) {
                price.insertAdjacentHTML("afterend", `<div class = "price-secondary-wrapper" style = "flex: 1; display: flex"></div>`)

                const priceSecondaryWrapper = document.querySelector(".price-secondary-wrapper");

                if (priceSecondaryWrapper) {
                    priceSecondaryWrapper.append(priceSecondaryLabel, priceSecondary);
                }
            }
        }

        $(".cart-inner").prepend(
            isEN ? "<h1>Shopping cart</h1>" : "<h1>Nákupní košík</h1>"
        );

        $("#order-page-login-button").insertAfter(".co-contact-information h4");
        $("#order-page-login-button").addClass("button-secondary");

        if ($(".in-krok-1,.in-step-1").length > 0) {
            $(deliveryType).insertBefore(
                ".recapitulation-shipping-billing:not(.recapitulation-shipping-billing.last)"
            );

            $(paymentType).insertBefore(".recapitulation-shipping-billing.last");

            const freeDeliveryAmountText = isEUR ? "40 €" : "1000 Kč";
            const freeDeliveryText = isEN ?
                `Add items for <strong>${freeDeliveryAmountText}</strong> to get <strong>FREE</strong> shipping.`
                : `Objednejte za <strong>${freeDeliveryAmountText}<strong> a víc a budete mít dopravu <strong>ZDARMA</strong>.`;
            const freeDeliveryHtml = `<div class="notice-right">
    <span>
        ${ freeDeliveryText }
    </span>
</div>`

            const deliveryMethods = $("#order-shipping-methods #shipping-6 .payment-shipping-price");
            if (deliveryMethods.length > 0 && deliveryMethods[0].innerText != "FREE" && deliveryMethods[0].innerText != "ZDARMA")
            {
                $("#order-shipping-methods").append(freeDeliveryHtml);
            }

            //Countries sort
            var countryDropDown = $("#deliveryCountryId")
            var czCountry = countryDropDown.find("[value='43']");
            var esCountry = countryDropDown.find("[value='52']");
            czCountry.remove();
            esCountry.remove();
            countryDropDown.prepend(0, esCountry);
            countryDropDown.prepend(0, czCountry);

            //Select country logic
            const countryCookieName = "user_countryId";
            if (!shoptet.cookie.get(countryCookieName))
            {
                var countryCodeByIp = "CZ";
                $.get("https://ipinfo.io", function(response) { countryCodeByIp = response.country; }, "jsonp");

                const shoptetCountryId = mapCountryCodetoShoptetId(countryCodeByIp);

                shoptet.cookie.create(countryCookieName, shoptetCountryId, {days: 30});
                $("#deliveryCountryId").val(shoptetCountryId).trigger("change");
            }
            else {
                const selectedOption = $("#deliveryCountryId option:selected");
                if (selectedOption) {
                    var countryIdFromDropDown = selectedOption.attr("value");
                    shoptet.cookie.create(countryCookieName, countryIdFromDropDown, {days: 30});
                }
            }
        }

        if ($(".in-krok-2,.in-step-2").length > 0) {
          const registerCheckBox=`<div class="form-group">
    <label for="register">&nbsp;</label>
    <div style="display: inline-block;">
        <input type="checkbox" name="setRegistration" id="set-registration" value="1" data-unveil="reg-info">
        <label for="set-registration" class="whole-width">
            ${ isEN ? "I want to register" : "Chci se registrovat v e-shopu" }
            <span id="reg-info" class="js-hidden additional-information">
            ${ isEN ? "(Information will be sent to you by e-mail)" : "(Informace Vám budou zaslány e-mailem)" }
            </span>
        </label>
    </div>
</div>`;
            $(".form-group #set-registration").parent().remove();

            const loginButton = $(".co-contact-information .btn.btn-secondary").parent().parent();
            $(registerCheckBox).insertAfter(loginButton);
        }

        $(".checkout-box-wrapper .mail").parent().append(`
    <span class='mail' itemprop='email'>
      <a href='mailto:ask@theminers.eu'>
        ask@theminers.eu
      </a>
    </span>
    `);

        const customFooter = `
        <div class="footer">
          <div class="footer__inner">
            <div class="copy">
              <span>${copyrightText}</span>
            </div>
            <div class="signature">
              <span>Vytvořilo</span>
                <a href="https://liffstudio.com/" target="_blank" class="liffstudio">
                  Liff Studio
                </a>
              <span>
                na platformě
              </span>
              <a href="https://www.shoptet.cz/?utm_source=footer&amp;utm_medium=link&amp;utm_campaign=create_by_shoptet" title="Shoptet" class="title" target="_blank">Shoptet</a>
            </div>
          </div>
        </div>
      `;

        $("#content-wrapper").append(customFooter);
        const submitOrder = isEN ? "Place order" : "Odeslat objednávku";
        $("#submit-order").html(submitOrder);

        const consent = document.querySelector(".consents.consents-first label");

        if (consent) {
            if (isEN) {
                consent.innerHTML = "By submitting the order, you agree to our <a href=\"/obchodni-podminky/\" target=\"_blank\" rel=\"noopener noreferrer\">Terms and Conditions</a> and <a href=\"/podminky-ochrany-osobnich-udaju/\" target=\"_blank\" rel=\"noopener noreferrer\">Privacy Policy</a>"
            }
        }
    }
};